import type { CompetitionView } from '@ps/isp-web-services-types';
import React from 'react';

import { useRegulatoryIntl } from '@swf/core/hooks/useRegulatoryIntl';

import CompetitionLink from '../CompetitionsLink/CompetitionsLink';

import { TXTWCL_N0_logo } from './CompetitionTitle.messages.json';
import styles from './CompetitionTitle.scss';

interface Props {
  isNested: boolean;
  competition: CompetitionView;
}

const CompetitionTitle: React.FC<Props> = ({
  isNested,
  competition: { competitionId, competitionName, logoUrl }
}) => {
  const { formatMessage } = useRegulatoryIntl();

  return isNested ? (
    <CompetitionLink competitionId={competitionId} logoUrl={logoUrl} />
  ) : (
    <>
      {logoUrl ? (
        <img
          className={styles.logoImg}
          src={logoUrl}
          alt={formatMessage(TXTWCL_N0_logo, { competitionName })}
        />
      ) : null}
      {competitionName}
    </>
  );
};

export default CompetitionTitle;
